/*
 * JD Health Tech hearing check & amplifier finder.
 * Markup and settings: sections/hearing-check.liquid. Styles: assets/hearing-check.css.
 * Products, prices and images come from the section's product pickers, so they stay in sync with Shopify.
 */
(function () {
  'use strict';

  var QUESTIONS = [
    {
      id: 'flags', multi: true,
      q: 'First, a quick health check. Have you noticed any of the following?',
      hint: 'Choose all that apply. Some symptoms should always be checked by a doctor first.',
      opts: [
        { t: 'A sudden change in my hearing', flag: true },
        { t: 'Hearing noticeably worse in one ear', flag: true },
        { t: 'Ear pain, discharge or a blocked feeling', flag: true },
        { t: 'New or worsening ringing in my ears', flag: true },
        { t: 'My hearing has gradually worsened over time', gradual: true },
        { t: 'None of these', none: true }
      ]
    },
    {
      id: 'situations', multi: true,
      q: 'Where do you most notice yourself straining to hear?',
      hint: 'Choose all that apply.',
      opts: [
        { t: 'Conversations in restaurants or cafés', s: 1 },
        { t: 'TV or radio (others say it’s too loud)', s: 1 },
        { t: 'Group meetings or family gatherings', s: 1 },
        { t: 'Phone or video calls', s: 1 },
        { t: 'Quiet one-to-one conversations', s: 2 },
        { t: 'None of these, just curious', s: 0, none: true }
      ]
    },
    {
      id: 'repeat', multi: false,
      q: 'How often do you ask people to repeat themselves?',
      opts: [
        { t: 'Rarely', s: 0 },
        { t: 'Occasionally', s: 1 },
        { t: 'Often', s: 2 },
        { t: 'In most conversations', s: 3 }
      ]
    },
    {
      id: 'where', multi: false,
      q: 'Where would you mostly use an amplifier?',
      opts: [
        { t: 'At home (TV and conversation)', v: 'home' },
        { t: 'Social settings (restaurants, gatherings)', v: 'social' },
        { t: 'At work (meetings and calls)', v: 'work' },
        { t: 'A bit of everything', v: 'all' }
      ]
    },
    {
      id: 'priority', multi: false,
      q: 'What matters most to you in a hearing amplifier?',
      opts: [
        { t: 'Being as discreet as possible', v: 'discreet' },
        { t: 'Simple to use, no apps or settings', v: 'simple' },
        { t: 'Fine-tuning the sound to my ears', v: 'tune' },
        { t: 'Keeping the cost down', v: 'cost' }
      ]
    },
    {
      id: 'apps', multi: false,
      q: 'How comfortable are you with smartphone apps?',
      // Someone who has just said "no apps" doesn't need to be asked.
      skip: function (a) { return valueOf('priority', a) === 'simple'; },
      opts: [
        { t: 'Very comfortable, happy to fine-tune settings', v: 'high' },
        { t: 'Fairly comfortable', v: 'mid' },
        { t: 'I’d rather avoid them', v: 'low' }
      ]
    },
    {
      id: 'dexterity', multi: false,
      q: 'How easy do you find handling small, fiddly things, like picking up a coin or fastening small buttons?',
      hint: 'In-ear amplifiers are very small, so this helps us suggest a style you’ll find easy to put in and adjust.',
      opts: [
        { t: 'Easy', v: 'easy' },
        { t: 'A bit tricky', v: 'some' },
        { t: 'Difficult', v: 'hard' }
      ]
    }
  ];

  var FREQS = [500, 1000, 2000, 4000];
  var FALLBACK_ORDER = ['micro', 'bestseller', 'display', 'home', 'easy_bte', 'app_cic', 'app_bte', 'budget'];
  var PANELS = ['intro', 'quiz', 'toneoffer', 'calibrate', 'tones', 'earswitch', 'results'];

  function qIndex(id) { for (var i = 0; i < QUESTIONS.length; i++) { if (QUESTIONS[i].id === id) return i; } return -1; }
  function valueOf(id, a) {
    var q = QUESTIONS[qIndex(id)];
    var sel = a[id];
    return (sel && sel.length) ? q.opts[sel[0]].v : null;
  }
  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function reducedMotion() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  function HearingCheck(root) {
    this.root = root;
    var cfgEl = root.querySelector('script[data-jdht-hc-config]');
    this.cfg = cfgEl ? JSON.parse(cfgEl.textContent) : { products: {} };
    this.audioCtx = null;
    this.reset();
    this.bind();
  }

  var P = HearingCheck.prototype;

  P.el = function (name) { return this.root.querySelector('[data-el="' + name + '"]'); };

  P.reset = function () {
    this.stopTone();
    this.state = {
      history: [], step: 0, answers: {},
      toneIdx: -1, thresholds: { right: {}, left: {} }, avg: { right: 0, left: 0 },
      tonesTaken: false, tonesUnreliable: false, calPlayed: false, toneReady: false, moved: false,
      live: null, pulseTimer: null, autoTimer: null, lastResult: null, productsShown: false
    };
  };

  P.tag = function (k, v) { try { if (window.clarity) window.clarity('set', k, String(v)); } catch (e) {} };

  P.announce = function (msg) {
    var live = this.el('live');
    if (!live) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 50);
  };

  P.showPanel = function (name) {
    var self = this;
    PANELS.forEach(function (p) { self.el(p).classList.toggle('jdht-hc-hide', p !== name); });
    this.el('steps').classList.toggle('jdht-hc-hide', name === 'intro');
    var stepFor = { quiz: 0, toneoffer: 1, calibrate: 1, tones: 1, earswitch: 1, results: 2 };
    if (name in stepFor) this.setStep(stepFor[name]);
    var panel = this.el(name);
    var focusTarget = panel.querySelector('[data-focus]');
    if (focusTarget) focusTarget.focus({ preventScroll: true });
    // Leave room for the sticky header so the question isn't hidden under it.
    var top = this.root.getBoundingClientRect().top + window.pageYOffset - 90;
    if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: reducedMotion() ? 'auto' : 'smooth' });
  };

  P.setStep = function (n) {
    var items = this.el('steps').querySelectorAll('[data-step]');
    for (var i = 0; i < items.length; i++) {
      items[i].className = 'jdht-hc-step' + (i < n ? ' done' : (i === n ? ' active' : ''));
      if (i === n) items[i].setAttribute('aria-current', 'step'); else items[i].removeAttribute('aria-current');
    }
  };

  /* ---------- Questions ---------- */

  P.isSkipped = function (i) { var q = QUESTIONS[i]; return !!(q.skip && q.skip(this.state.answers)); };

  P.visibleCount = function () {
    var n = 0;
    for (var i = 0; i < QUESTIONS.length; i++) { if (!this.isSkipped(i)) n++; }
    return n;
  };

  P.renderStep = function () {
    var s = this.state;
    var q = QUESTIONS[s.step];
    var position = s.history.length + 1;
    var total = this.visibleCount();
    var label = 'Question ' + position + ' of ' + total;
    this.el('stepcount').textContent = label;
    var pct = Math.round((position - 1) / total * 100);
    this.el('bar').style.width = pct + '%';
    this.el('progress').setAttribute('aria-valuenow', pct);
    this.el('q').textContent = q.q;
    this.el('qhint').textContent = q.hint || '';
    this.el('qhint').classList.toggle('jdht-hc-hide', !q.hint);
    this.el('qerror').classList.add('jdht-hc-hide');

    var box = this.el('opts');
    box.innerHTML = '';
    var selected = s.answers[q.id] || [];
    var name = 'jdht-hc-' + q.id;
    q.opts.forEach(function (opt, i) {
      var label = document.createElement('label');
      label.className = 'jdht-hc-opt' + (q.multi ? ' is-multi' : '');
      var input = document.createElement('input');
      input.type = q.multi ? 'checkbox' : 'radio';
      input.name = name;
      input.value = i;
      input.checked = selected.indexOf(i) > -1;
      if (opt.none) input.setAttribute('data-none', '');
      var tick = document.createElement('span');
      tick.className = 'jdht-hc-tick';
      tick.setAttribute('aria-hidden', 'true');
      tick.textContent = '✓';
      var text = document.createElement('span');
      text.textContent = opt.t;
      label.appendChild(input); label.appendChild(tick); label.appendChild(text);
      box.appendChild(label);
    });
    this.showPanel('quiz');
    this.announce(label);
  };

  P.onOptionChange = function (input) {
    var q = QUESTIONS[this.state.step];
    var inputs = this.el('opts').querySelectorAll('input');
    if (q.multi && input.checked) {
      var isNone = input.hasAttribute('data-none');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i] !== input && (isNone || inputs[i].hasAttribute('data-none'))) inputs[i].checked = false;
      }
    }
    var sel = [];
    for (var k = 0; k < inputs.length; k++) { if (inputs[k].checked) sel.push(k); }
    this.state.answers[q.id] = sel;
    this.el('qerror').classList.add('jdht-hc-hide');
  };

  P.next = function () {
    var s = this.state;
    var q = QUESTIONS[s.step];
    if (!s.answers[q.id] || !s.answers[q.id].length) {
      this.el('qerror').classList.remove('jdht-hc-hide');
      return;
    }
    if (q.id === 'flags') {
      var flagged = s.answers.flags.some(function (i) { return q.opts[i].flag; });
      if (flagged) {
        // No point asking about amplifier preferences or running tones: go straight to the GP advice.
        this.tag('hearing_check_gp_exit', 'true');
        this.renderResults();
        return;
      }
    }
    s.history.push(s.step);
    var nextStep = s.step + 1;
    while (nextStep < QUESTIONS.length && this.isSkipped(nextStep)) nextStep++;
    if (nextStep < QUESTIONS.length) { s.step = nextStep; this.renderStep(); }
    else { this.showPanel('toneoffer'); }
  };

  P.back = function () {
    var s = this.state;
    if (s.history.length) { s.step = s.history.pop(); this.renderStep(); }
    else { this.showPanel('intro'); }
  };

  /* ---------- Audio ---------- */

  P.ctx = function () {
    if (!this.audioCtx) this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    if (this.audioCtx.state === 'suspended') this.audioCtx.resume();
    return this.audioCtx;
  };

  // Route a mono node to one ear. ChannelMerger works on older Safari, unlike StereoPannerNode.
  P.route = function (node, ear) {
    var c = this.audioCtx;
    if (!ear) { node.connect(c.destination); return; }
    var merger = c.createChannelMerger(2);
    node.connect(merger, 0, ear === 'left' ? 0 : 1);
    merger.connect(c.destination);
  };

  // Slider position 0-100 maps to an 80 dB range; 100 matches the calibration tone level.
  function posToGain(pos) { return 0.5 * Math.pow(10, (pos - 100) / 25); }

  P.beep = function (freq, gainVal, dur, circle) {
    var c = this.ctx();
    var osc = c.createOscillator();
    var g = c.createGain();
    osc.type = 'sine';
    osc.frequency.value = freq;
    g.gain.setValueAtTime(0, c.currentTime);
    g.gain.linearRampToValueAtTime(gainVal, c.currentTime + 0.08);
    g.gain.setValueAtTime(gainVal, c.currentTime + dur - 0.08);
    g.gain.linearRampToValueAtTime(0, c.currentTime + dur);
    osc.connect(g);
    this.route(g, null);
    osc.start(); osc.stop(c.currentTime + dur);
    if (circle) circle.classList.add('playing');
    setTimeout(function () { if (circle) circle.classList.remove('playing'); }, dur * 1000 + 50);
  };

  P.stopTone = function () {
    var s = this.state;
    if (!s) return;
    clearTimeout(s.autoTimer);
    if (s.pulseTimer) { clearInterval(s.pulseTimer); s.pulseTimer = null; }
    if (s.live) { try { s.live.osc.stop(); } catch (e) {} s.live = null; }
    var circle = this.el('livecircle');
    if (circle) circle.classList.remove('live');
  };

  P.startTone = function (freq, ear, pos) {
    this.stopTone();
    var s = this.state;
    var c = this.ctx();
    var osc = c.createOscillator();
    var g = c.createGain();
    osc.type = 'sine';
    osc.frequency.value = freq;
    g.gain.value = 0;
    osc.connect(g);
    this.route(g, ear);
    osc.start();
    s.live = { osc: osc, gain: g, target: posToGain(pos), on: false };
    s.pulseTimer = setInterval(function () {
      if (!s.live) return;
      s.live.on = !s.live.on;
      var now = c.currentTime;
      var gg = s.live.gain.gain;
      gg.cancelScheduledValues(now);
      gg.setValueAtTime(gg.value, now);
      gg.linearRampToValueAtTime(s.live.on ? s.live.target : 0, now + 0.06);
    }, 380);
    var circle = this.el('livecircle');
    circle.textContent = 'Tone playing';
    circle.classList.add('live');
    s.toneReady = true;
    this.updateToneButtons();
  };

  /* ---------- Sound check ---------- */

  P.readyCheck = function () {
    var ready = this.el('ckHead').checked && this.el('ckVol').checked;
    var circle = this.el('calcircle');
    circle.disabled = !ready;
    circle.textContent = ready ? (this.state.calPlayed ? 'Play again' : 'Play the tone') : 'Tick both boxes first';
    this.el('beginbtn').disabled = !(ready && this.state.calPlayed);
  };

  P.playCalibration = function () {
    this.state.calPlayed = true;
    this.beep(1000, 0.5, 1.2, this.el('calcircle'));
    this.readyCheck();
    this.announce('Tone played. Adjust your device volume until it is clear and comfortable.');
  };

  P.currentTone = function () {
    var i = this.state.toneIdx;
    if (i < 0) return { f: 1000, ear: null };
    return { f: FREQS[i % 4], ear: i < 4 ? 'right' : 'left' };
  };

  P.renderTone = function () {
    var s = this.state;
    var practice = s.toneIdx < 0;
    var t = this.currentTone();
    var earLabel = practice ? 'Practice' : (t.ear === 'right' ? 'Right' : 'Left');
    this.el('tonecount').textContent = practice ? 'Practice round (not scored)' : earLabel + ' ear: tone ' + ((s.toneIdx % 4) + 1) + ' of 4';
    this.el('earheading').textContent = practice ? 'Practice round' : earLabel + ' ear';
    this.el('earhint').innerHTML = practice
      ? 'You’ll hear a gentle pulsing tone in both ears. Use the <strong>−</strong> and <strong>+</strong> buttons (or the slider) to find the quietest level you can still just hear, then press the button. This round is just for practice.'
      : 'A pulsing tone is playing in your <strong>' + earLabel.toLowerCase() + ' ear only</strong>. Find the quietest level you can still just hear. If you can’t hear it, turn it up.';
    var pct = practice ? 0 : Math.round(s.toneIdx / 8 * 100);
    this.el('tonebar').style.width = pct + '%';
    this.el('toneprogress').setAttribute('aria-valuenow', pct);

    // Start somewhere different each time so the slider position can't simply be repeated.
    var slider = this.el('slider');
    slider.value = 55 + Math.floor(Math.random() * 26);
    this.updateSliderText();
    s.moved = false;
    s.toneReady = false;
    this.el('toneerror').classList.add('jdht-hc-hide');
    var circle = this.el('livecircle');
    circle.textContent = 'Tone starting…';
    circle.classList.remove('live');
    this.updateToneButtons();
    this.showPanel('tones');
    this.announce(this.el('tonecount').textContent);

    var self = this;
    clearTimeout(s.autoTimer);
    s.autoTimer = setTimeout(function () { self.startTone(t.f, t.ear, parseInt(slider.value, 10)); }, 900);
  };

  P.updateToneButtons = function () {
    var s = this.state;
    this.el('confirmbtn').disabled = !s.toneReady;
    this.el('canthearbtn').disabled = !s.toneReady;
  };

  P.updateSliderText = function () {
    var slider = this.el('slider');
    slider.setAttribute('aria-valuetext', 'Tone volume ' + slider.value + ' out of 100');
  };

  P.setToneVolume = function (v) {
    var s = this.state;
    var slider = this.el('slider');
    slider.value = Math.max(0, Math.min(100, v));
    this.updateSliderText();
    s.moved = true;
    this.el('toneerror').classList.add('jdht-hc-hide');
    if (!s.live) return;
    s.live.target = posToGain(parseInt(slider.value, 10));
    if (s.live.on && this.audioCtx) {
      var now = this.audioCtx.currentTime;
      var gg = s.live.gain.gain;
      gg.cancelScheduledValues(now);
      gg.setValueAtTime(gg.value, now);
      gg.linearRampToValueAtTime(s.live.target, now + 0.05);
    }
  };

  P.replayTone = function () {
    var t = this.currentTone();
    this.ctx();
    this.startTone(t.f, t.ear, parseInt(this.el('slider').value, 10));
  };

  P.recordThreshold = function (pos) {
    var s = this.state;
    this.stopTone();
    if (s.toneIdx >= 0) {
      var t = this.currentTone();
      s.thresholds[t.ear][t.f] = pos;
    }
    s.toneIdx++;
    if (s.toneIdx === 0) { s.tonesTaken = true; this.renderTone(); }
    else if (s.toneIdx === 4) { this.showPanel('earswitch'); }
    else if (s.toneIdx >= 8) { this.tag('hearing_check_sound_check', 'completed'); this.renderResults(); }
    else { this.renderTone(); }
  };

  P.confirmThreshold = function () {
    if (!this.state.moved) {
      // Pressing straight away just records wherever the slider happened to start.
      var err = this.el('toneerror');
      err.textContent = 'Please adjust the volume first: turn it down until the tone is only just audible, or up if you can’t hear it.';
      err.classList.remove('jdht-hc-hide');
      return;
    }
    this.recordThreshold(parseInt(this.el('slider').value, 10));
  };

  P.cantHear = function () {
    var slider = this.el('slider');
    if (parseInt(slider.value, 10) < 100) {
      this.setToneVolume(100);
      this.replayTone();
      var err = this.el('toneerror');
      err.textContent = 'We’ve turned the tone up to full volume. If you still can’t hear it, press the button again.';
      err.classList.remove('jdht-hc-hide');
      return;
    }
    this.recordThreshold(100);
  };

  /* ---------- Scoring ---------- */

  P.computeResult = function () {
    var s = this.state;
    var a = s.answers;
    var flagsQ = QUESTIONS[qIndex('flags')];
    var flags = (a.flags || []).some(function (i) { return flagsQ.opts[i].flag; });
    var gradual = (a.flags || []).some(function (i) { return flagsQ.opts[i].gradual; });

    if (flags) return { band: 'gp', flags: true };

    var sitQ = QUESTIONS[qIndex('situations')];
    var sitScore = 0;
    (a.situations || []).forEach(function (i) { sitScore += sitQ.opts[i].s || 0; });
    if (sitScore > 3) sitScore = 3;
    var repScore = (a.repeat && a.repeat.length) ? QUESTIONS[qIndex('repeat')].opts[a.repeat[0]].s : 0;

    var toneScore = 0;
    var asym = null;
    s.tonesUnreliable = false;
    if (s.tonesTaken) {
      var ears = ['right', 'left'];
      var avg = { right: 0, left: 0 };
      var all = [];
      for (var e = 0; e < 2; e++) {
        for (var fi = 0; fi < FREQS.length; fi++) {
          var pos = s.thresholds[ears[e]][FREQS[fi]];
          if (typeof pos !== 'number') pos = 70;
          all.push(pos);
          avg[ears[e]] += pos / FREQS.length;
          toneScore += (pos > 75 ? 0.375 : (pos > 55 ? 0.25 : (pos > 35 ? 0.12 : 0)));
        }
      }
      // Near-identical answers for every tone usually mean the sound wasn't coming through (muted device,
      // no headphones) or the buttons were pressed without listening. Leave the tones out rather than guess.
      if (Math.max.apply(null, all) - Math.min.apply(null, all) < 4) {
        s.tonesUnreliable = true;
        toneScore = 0;
      } else {
        s.avg = avg;
        toneScore = Math.min(3, toneScore);
        if (avg.left - avg.right >= 15) asym = 'left';
        if (avg.right - avg.left >= 15) asym = 'right';
      }
    }
    var total = sitScore + repScore + toneScore + (gradual ? 1 : 0);

    var band;
    if (sitScore === 0 && repScore === 0 && !gradual && toneScore < 1) band = 'none';
    else if (total <= 2) band = 'mild';
    else if (total <= 6) band = 'moderate';
    else band = 'high';

    var picks = this.pickProducts(a);
    return { band: band, flags: false, gradual: gradual, asym: asym, rec: picks.rec, alt: picks.alt, reason: picks.reason, total: Math.round(total) };
  };

  P.pickProducts = function (a) {
    var priority = valueOf('priority', a) || 'simple';
    var apps = valueOf('apps', a) || 'low';
    var where = valueOf('where', a) || 'all';
    var dex = valueOf('dexterity', a) || 'easy';
    var busy = where === 'social' || where === 'work';
    var pair, reason;

    if (dex !== 'easy') {
      reason = 'You mentioned small, fiddly things can be tricky, so we’ve suggested behind-the-ear styles, which are larger and easier to handle than in-ear models.';
      if (apps !== 'low' && (priority === 'tune' || busy)) pair = ['app_bte', 'easy_bte'];
      else if (priority === 'cost') pair = ['easy_bte', 'budget'];
      else pair = ['easy_bte', apps === 'low' ? 'budget' : 'app_bte'];
    } else if (priority === 'tune') {
      if (apps !== 'low') {
        pair = ['app_cic', busy ? 'app_bte' : 'micro'];
        reason = 'You want to fine-tune the sound and are happy using an app, so we’ve suggested models you can adjust for each ear from your phone.';
      } else {
        pair = ['micro', 'display'];
        reason = 'You’d like to adjust the sound but would rather avoid apps, so we’ve suggested models with simple button controls and listening modes.';
      }
    } else if (priority === 'discreet') {
      pair = apps === 'high' ? ['app_cic', 'micro'] : ['micro', apps === 'mid' ? 'app_cic' : 'display'];
      reason = 'Being discreet matters most to you, so we’ve suggested our in-canal models, which sit low inside the ear.';
    } else if (priority === 'cost') {
      pair = where === 'home' ? ['home', 'bestseller'] : ['bestseller', 'budget'];
      reason = 'Keeping the cost down matters most to you, so we’ve suggested our best-value models' + (where === 'home' ? ' for everyday listening at home.' : '.');
    } else {
      pair = where === 'home' ? ['bestseller', 'home'] : ['micro', 'bestseller'];
      reason = 'You want something simple, so we’ve suggested models with no app or pairing: switch on, set the volume and go.';
    }

    var products = this.cfg.products || {};
    function usable(role) { return products[role] && products[role].available; }
    var rec = usable(pair[0]) ? pair[0] : null;
    var alt = usable(pair[1]) && pair[1] !== rec ? pair[1] : null;
    for (var i = 0; (!rec || !alt) && i < FALLBACK_ORDER.length; i++) {
      var role = FALLBACK_ORDER[i];
      if (!usable(role) || role === rec || role === alt) continue;
      if (!rec) rec = role; else if (!alt) alt = role;
    }
    return { rec: rec, alt: alt, reason: reason };
  };

  /* ---------- Results ---------- */

  var BAND_COPY = {
    none: {
      cls: 'jdht-hc-band-blue',
      title: 'You don’t seem to be struggling with everyday listening right now',
      body: 'Based on your answers, you’re not noticing the kind of everyday difficulty a personal sound amplifier is designed to help with, so we wouldn’t suggest buying one at the moment. Hearing can change gradually, so it’s worth taking this check again in a year or so, or sooner if you find yourself turning the TV up or asking people to repeat themselves.'
    },
    mild: {
      cls: 'jdht-hc-band-amber',
      title: 'You may notice a modest benefit',
      body: 'Your answers suggest only occasional listening difficulty. A personal sound amplifier may help in specific situations, like a noisy restaurant or quiet TV dialogue, but you might not feel you need one every day. An affordable model is a sensible way to find out, and most of our amplifiers come with a 30-day home trial.'
    },
    moderate: {
      cls: 'jdht-hc-band-green',
      title: 'A hearing amplifier is likely to help your everyday listening',
      body: 'Your answers match the everyday listening challenges our customers most often describe: straining in background noise, turning the TV up, asking people to repeat themselves. Personal sound amplifiers are designed for exactly these mild-to-moderate situations, and this is where customers tell us they notice the biggest difference. Most of our amplifiers come with a 30-day home trial, so you can try one at home and send it back if it doesn’t suit.'
    },
    high: {
      cls: 'jdht-hc-band-red',
      title: 'You may need more support than an amplifier provides',
      body: 'Honest answer: your responses suggest your listening difficulties may go beyond what a personal sound amplifier is designed for. We’d recommend speaking to your GP or booking a free hearing test with a high-street audiologist first. If a full hearing aid isn’t right for you yet, an amplifier can still help in everyday situations, but we’d rather set realistic expectations than sell you something that disappoints.'
    },
    gp: {
      cls: 'jdht-hc-band-red',
      title: 'Please see your GP before considering any listening product'
    }
  };

  var NHS_LINK = '<a href="https://www.nhs.uk/conditions/hearing-loss/" target="_blank" rel="noopener">NHS hearing loss guide<span class="jdht-hc-sr"> (opens in a new tab)</span></a>';

  P.renderResults = function () {
    var self = this;
    var s = this.state;
    var r = this.computeResult();
    s.lastResult = r;
    s.productsShown = false;
    this.stopTone();
    this.tag('hearing_check_completed', 'true');
    if (this.cfg.clarityBand) this.tag('hearing_check_band', r.band);

    var html = '';
    if (r.flags) {
      html += '<div class="jdht-hc-band jdht-hc-band-red"><h2 tabindex="-1" data-focus>' + BAND_COPY.gp.title + '</h2>'
        + '<p>You mentioned one or more symptoms, such as a sudden change in hearing, hearing worse in one ear, ear pain or discharge, or new ringing, that should always be checked by a doctor first. That’s why we’ve stopped the check here: this isn’t a reason to worry, but it is a reason to get proper medical advice before using any amplification product.</p>'
        + '<p>Your GP can look into what’s causing it and refer you for a full hearing test if needed. The ' + NHS_LINK + ' explains what to expect. Once you’ve been checked over, we’d be happy to help you find the right option. This check will still be here.</p></div>';
    } else {
      var bc = BAND_COPY[r.band];
      html += '<div class="jdht-hc-band ' + bc.cls + '"><h2 tabindex="-1" data-focus>' + bc.title + '</h2><p>' + bc.body + '</p></div>';
      if (s.tonesTaken && s.tonesUnreliable) {
        html += '<div class="jdht-hc-note">You gave almost the same answer for every tone, which usually means the sound wasn’t coming through properly (for example, the device was muted or on silent). So we’ve based your result on your answers only. You can start again to retry the sound check.</div>';
      } else if (s.tonesTaken) {
        html += '<div class="jdht-hc-gauges">' + earGauge('L', 'Left ear', s.avg.left) + earGauge('R', 'Right ear', s.avg.right) + '</div>'
          + '<p class="jdht-hc-small jdht-hc-center">These dials show how easily each ear picked up the quiet test tones. This is an informal indication only, not a measurement of hearing.</p>';
      }
      if (r.gradual) {
        html += '<div class="jdht-hc-note">You mentioned your hearing has gradually changed over time. This is very common, and it’s worth having it checked properly at some point. Many high-street opticians and audiologists offer free hearing tests, and the ' + NHS_LINK + ' is a good starting point.' + (r.band === 'none' ? '' : ' In the meantime, a personal sound amplifier can support everyday listening in mild-to-moderate situations.') + '</div>';
      }
      if (r.asym) {
        html += '<div class="jdht-hc-note">You seemed to notice fewer of the tones in your <strong>' + r.asym + ' ear</strong>. An informal check like this can’t measure that reliably, but a noticeable difference between ears is worth mentioning to your GP or an audiologist.</div>';
      }

      var cards = this.productCards(r);
      if (r.band === 'none') {
        html += '<p class="jdht-hc-center"><a href="' + esc(this.cfg.collectionUrl) + '">Curious anyway? See how our amplifiers work</a></p>';
      } else if (cards && r.band === 'high') {
        html += '<div class="jdht-hc-note" data-el="gate"><p><strong>Would you still like to see amplifier options?</strong> Personal sound amplifiers are designed for mild-to-moderate everyday listening, so they may not fully meet your needs.</p>'
          + '<div class="jdht-hc-btnrow" style="margin-top:12px">'
          + '<button type="button" class="jdht-hc-btn" data-action="showHighOptions">Yes, show me the options</button>'
          + '<button type="button" class="jdht-hc-btn-ghost" data-action="declineHighOptions">No, I’ll speak to my GP first</button>'
          + '</div></div>'
          + '<div data-el="highprods" class="jdht-hc-hide"><h2 style="margin-top:24px" tabindex="-1" data-el="highprodsHeading">Amplifier options</h2>' + cards + '</div>';
      } else if (cards) {
        html += '<h2 style="margin-top:24px">Our recommendation for you</h2>' + cards;
        s.productsShown = true;
        this.tag('hearing_check_recommendation', r.rec);
      }
    }

    html += this.emailBox();
    html += '<div class="jdht-hc-btnrow"><button type="button" class="jdht-hc-back" data-action="restart">Start again</button></div>';
    html += '<div class="jdht-hc-disclaimer">This check is an informal screening tool to help you decide whether a personal sound amplifier might suit your everyday listening needs. It is not a medical hearing test and cannot diagnose hearing loss or any medical condition. JD Health Tech products are personal sound amplifiers, not medical hearing aids. If you have concerns about your hearing health, please speak to your GP. Results from the sound check vary with your device, headphones and environment.</div>';

    this.el('results').innerHTML = html;
    this.showPanel('results');
    this.announce('Your results are ready.');
    if (self.cfg.debug) window.jdhtHCLastResult = r;
  };

  P.productCards = function (r) {
    var products = this.cfg.products || {};
    var rec = products[r.rec], alt = products[r.alt];
    if (!rec) return '';
    return '<p>' + esc(r.reason) + '</p>'
      + prodCard(rec, 'Best match for you', false, this.cfg)
      + (alt ? prodCard(alt, 'Also worth a look', true, this.cfg) : '')
      + '<a class="jdht-hc-btn-browse" href="' + esc(this.cfg.collectionUrl) + '">Browse all hearing amplifiers →</a>';
  };

  function earSummaryShort(avg) {
    if (avg <= 40) return 'Picked up the quiet tones well';
    if (avg <= 60) return 'Needed a little more volume';
    return 'Needed noticeably more volume';
  }

  function earGauge(letter, earName, avg) {
    var pct = Math.max(8, Math.min(100, 100 - avg));
    var col = avg <= 40 ? '#3d9a68' : (avg <= 60 ? '#e8a13c' : '#e26d5c');
    var len = Math.round(220 * pct / 100);
    return '<div class="jdht-hc-gauge">'
      + '<svg viewBox="0 0 180 100" width="170" height="95" aria-hidden="true" focusable="false">'
      + '<path d="M 20 90 A 70 70 0 0 1 160 90" fill="none" stroke="#e8eef4" stroke-width="14" stroke-linecap="round"></path>'
      + '<path d="M 20 90 A 70 70 0 0 1 160 90" fill="none" stroke="' + col + '" stroke-width="14" stroke-linecap="round" stroke-dasharray="' + len + ' 220"></path>'
      + '</svg>'
      + '<div class="jdht-hc-gauge-letter" aria-hidden="true">' + letter + '</div>'
      + '<p class="jdht-hc-gauge-text"><span class="jdht-hc-sr">' + earName + ': </span>' + earSummaryShort(avg) + '</p>'
      + '</div>';
  }

  function prodCard(p, tagText, isAlt, cfg) {
    var lis = (p.why || []).map(function (w) { return String(w).trim(); }).filter(Boolean).map(function (w) {
      return '<li><span class="jdht-bullet" aria-hidden="true">✓</span><span>' + esc(w) + '</span></li>';
    }).join('');
    var compare = p.compare ? ' <s><span class="jdht-hc-sr">Was </span>' + esc(p.compare) + '</s>' : '';
    var note = p.clearance && cfg.clearanceNote ? '<p class="jdht-hc-prod-note">' + esc(cfg.clearanceNote) + '</p>' : '';
    return '<div class="jdht-hc-prod' + (isAlt ? ' alt' : '') + '">'
      + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="130" height="130">' : '')
      + '<div class="jdht-hc-prod-body">'
      + '<span class="jdht-hc-prod-tag">' + tagText + '</span>'
      + '<h3>' + esc(p.name) + '</h3>'
      + '<div class="jdht-hc-price">' + esc(p.price) + compare + '</div>'
      + '<ul class="jdht-hc-why">' + lis + '</ul>'
      + note
      + '<a class="jdht-hc-btn" href="' + esc(p.url) + '">View this amplifier<span class="jdht-hc-sr">: ' + esc(p.name) + '</span></a>'
      + '</div></div>';
  }

  P.emailBox = function () {
    var id = this.root.id || 'jdht-hc';
    var privacy = this.cfg.privacyUrl
      ? ' See our <a href="' + esc(this.cfg.privacyUrl) + '" target="_blank" rel="noopener">privacy policy<span class="jdht-hc-sr"> (opens in a new tab)</span></a> for how we store and use your information.'
      : '';
    return '<form class="jdht-hc-email" data-el="emailbox" novalidate>'
      + '<h3>Email me my results</h3>'
      + '<p class="jdht-hc-small">Optional: your results are already shown above. We’ll email you a copy so you can come back to it.</p>'
      + '<label class="jdht-hc-emaillabel" for="' + id + '-email">Email address</label>'
      + '<input type="email" id="' + id + '-email" data-el="emailinput" autocomplete="email" aria-describedby="' + id + '-emailmsg">'
      + '<div class="jdht-hc-checks">'
      + '<label class="jdht-hc-checklabel"><input type="checkbox" data-el="consentResults"><span>Yes, email me my results. I agree to JD Health Tech using my answers to send them. <em>(Required)</em></span></label>'
      + '<label class="jdht-hc-checklabel"><input type="checkbox" data-el="consentMarketing"><span>Also send me occasional hearing tips and offers. I can unsubscribe at any time. <em>(Optional)</em></span></label>'
      + '</div>'
      + '<p class="jdht-hc-small">' + privacy + '</p>'
      + '<p class="jdht-hc-error jdht-hc-hide" id="' + id + '-emailmsg" data-el="emailmsg" role="alert"></p>'
      + '<div class="jdht-hc-btnrow" style="margin-top:12px"><button type="submit" class="jdht-hc-btn" data-el="sendbtn">Send my results</button></div>'
      + '</form>';
  };

  P.bandLabel = function (r) {
    if (r.flags) return 'GP referral advised';
    if (r.band === 'none') return 'No amplifier needed right now';
    return BAND_COPY[r.band] ? BAND_COPY[r.band].title : '';
  };

  P.submitEmail = function () {
    var self = this;
    var s = this.state;
    var input = this.el('emailinput');
    var msg = this.el('emailmsg');
    var btn = this.el('sendbtn');
    var email = (input.value || '').trim();
    function fail(text, focusEl) {
      msg.textContent = text;
      msg.classList.remove('jdht-hc-hide');
      if (focusEl) focusEl.focus();
    }
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { input.setAttribute('aria-invalid', 'true'); return fail('Please enter a valid email address.', input); }
    input.removeAttribute('aria-invalid');
    if (!this.el('consentResults').checked) return fail('Please tick the first box so we can email your results.', this.el('consentResults'));
    var marketing = this.el('consentMarketing').checked;
    msg.classList.add('jdht-hc-hide');
    btn.disabled = true;
    btn.textContent = 'Sending…';

    var r = s.lastResult || {};
    var products = this.cfg.products || {};
    var today = new Date();
    var props = {
      source: 'Online Hearing Check',
      band: r.band || '',
      band_label: this.bandLabel(r),
      gp_referral: r.flags ? 'yes' : 'no',
      marketing_opt_in: marketing ? 'yes' : 'no',
      check_date: today.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }),
      check_date_iso: today.toISOString().slice(0, 10)
    };
    if (s.tonesTaken && !s.tonesUnreliable) {
      props.threshold_right_avg = Math.round(s.avg.right);
      props.threshold_left_avg = Math.round(s.avg.left);
    }
    // Only include products the customer was actually shown; never for GP-referral results.
    var showRec = !r.flags && s.productsShown && products[r.rec];
    if (showRec) {
      var site = this.cfg.siteUrl || '';
      props.recommendation_name = products[r.rec].name;
      props.recommendation_price = products[r.rec].price;
      props.recommendation_url = site + products[r.rec].url;
      if (products[r.alt]) {
        props.alternative_name = products[r.alt].name;
        props.alternative_price = products[r.alt].price;
        props.alternative_url = site + products[r.alt].url;
      }
    }

    var headers = { 'Content-Type': 'application/json', 'revision': '2024-10-15' };
    var company = encodeURIComponent(this.cfg.klaviyoCompanyId || '');
    var eventReq = fetch('https://a.klaviyo.com/client/events/?company_id=' + company, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            properties: props,
            metric: { data: { type: 'metric', attributes: { name: 'Hearing Check Completed' } } },
            profile: { data: { type: 'profile', attributes: {
              email: email,
              properties: {
                hearing_check_date: props.check_date_iso,
                hearing_check_recommendation: showRec ? products[r.rec].name : ''
              }
            } } }
          }
        }
      })
    });

    eventReq.then(function (res) {
      if (!res.ok) throw new Error('event ' + res.status);
      if (!marketing || !self.cfg.klaviyoListId) return false;
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + company, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Online Hearing Check',
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: self.cfg.klaviyoListId } } }
          }
        })
      }).then(function (subRes) { return subRes.ok; }).catch(function () { return false; });
    }).then(function (subscribed) {
      self.tag('hearing_check_email', 'captured');
      var box = self.el('emailbox');
      var success = document.createElement('div');
      success.className = 'jdht-hc-success';
      success.setAttribute('role', 'status');
      success.innerHTML = '<h3 tabindex="-1">✓ Your results are on their way</h3>'
        + '<p>We’ve sent your results to <strong>' + esc(email) + '</strong>. If nothing arrives within a few minutes, please check your spam or junk folder.</p>'
        + (subscribed ? '<p>You’ll also get a separate email asking you to confirm your subscription to our hearing tips.</p>' : '');
      box.parentNode.replaceChild(success, box);
      success.querySelector('h3').focus();
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = 'Send my results';
      fail('Sorry, something went wrong. Please check your connection and try again.');
    });
  };

  /* ---------- Events ---------- */

  P.bind = function () {
    var self = this;
    var root = this.root;
    var actions = {
      start: function () {
        self.reset();
        self.state.step = 0;
        self.tag('hearing_check_started', 'true');
        self.renderStep();
      },
      back: function () { self.back(); },
      startSoundCheck: function () {
        self.tag('hearing_check_sound_check', 'started');
        self.ctx();
        self.el('ckHead').checked = false;
        self.el('ckVol').checked = false;
        self.readyCheck();
        self.showPanel('calibrate');
      },
      skipTones: function () {
        self.tag('hearing_check_sound_check', 'skipped');
        self.state.tonesTaken = false;
        self.renderResults();
      },
      playCal: function () { self.playCalibration(); },
      beginTones: function () {
        self.state.toneIdx = -1;
        self.state.thresholds = { right: {}, left: {} };
        self.renderTone();
      },
      startLeft: function () { self.renderTone(); },
      replay: function () { self.replayTone(); },
      quieter: function () { self.setToneVolume(parseInt(self.el('slider').value, 10) - 5); },
      louder: function () { self.setToneVolume(parseInt(self.el('slider').value, 10) + 5); },
      confirm: function () { self.confirmThreshold(); },
      cantHear: function () { self.cantHear(); },
      showHighOptions: function () {
        self.el('gate').classList.add('jdht-hc-hide');
        self.el('highprods').classList.remove('jdht-hc-hide');
        self.el('highprodsHeading').focus();
        self.state.productsShown = true;
        self.tag('hearing_check_high_gate', 'yes');
        self.tag('hearing_check_recommendation', self.state.lastResult.rec);
      },
      declineHighOptions: function () {
        var gate = self.el('gate');
        gate.innerHTML = '<p tabindex="-1"><strong>That sounds like a sensible next step.</strong> Your GP can refer you for a full hearing test, or many high-street audiologists offer one free. The ' + NHS_LINK + ' explains what to expect. This check will still be here whenever you need it.</p>';
        gate.querySelector('p').focus();
        self.tag('hearing_check_high_gate', 'no');
      },
      restart: function () {
        self.reset();
        self.showPanel('intro');
      }
    };

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-action]');
      if (!t || !root.contains(t) || !actions[t.getAttribute('data-action')]) return;
      e.preventDefault();
      actions[t.getAttribute('data-action')](t);
    });

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.closest('[data-el="opts"]')) self.onOptionChange(t);
      else if (t === self.el('ckHead') || t === self.el('ckVol')) self.readyCheck();
    });

    root.addEventListener('input', function (e) {
      if (e.target === self.el('slider')) self.setToneVolume(parseInt(e.target.value, 10));
    });

    root.addEventListener('submit', function (e) {
      e.preventDefault();
      if (e.target === self.el('qform')) self.next();
      else if (e.target === self.el('emailbox')) self.submitEmail();
    });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden || !self.state.live && !self.state.autoTimer) return;
      self.stopTone();
      self.el('livecircle').textContent = 'Tap to play the tone';
    });
  };

  function init() {
    var roots = document.querySelectorAll('[data-jdht-hc]:not([data-jdht-hc-ready])');
    for (var i = 0; i < roots.length; i++) {
      roots[i].setAttribute('data-jdht-hc-ready', '');
      new HearingCheck(roots[i]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
